import { Skeleton } from "@mui/material";
import { LeadDetailsSkeletonSectionContainer } from "./LeadDetailsSkeleton.styles.tsx";

const LeadDetailsSkeleton = () => {
	return (
		<LeadDetailsSkeletonSectionContainer>
			<Skeleton
				variant="rectangular"
				width="100%"
				height="900px"
			/>
		</LeadDetailsSkeletonSectionContainer>
	);
};

export default LeadDetailsSkeleton;
